import React from 'react';
import PropTypes from 'prop-types';
import PaymentRatesListElement from './PaymentRatesListElement';

const PaymentRatesList = ({rates}) => (
  <div className="payment-rates-list">
    <div className="payment-rates-list__list">
      {rates.map(rate => <PaymentRatesListElement key={rate.paymentId} rate={rate} />)}
    </div>
  </div>
);

PaymentRatesList.PropTypes = {
  rates:PropTypes.array.isRequired,
};

export default PaymentRatesList;
